import { defineStore } from "pinia";

export const useFreeSearchGlobalStore = defineStore("freeSearchGlobal", {
  // State
  state: () => ({
    currentFreeSearch: "main",
  }),

  // Getters
  getters: {
    doubleCount: (state) => state.count * 2,
  },

  // Actions
  actions: {
    setCurrentFreeSearch(val) {
      this.currentFreeSearch = val;
    },
  },
});
